import { useParams, Link } from "react-router-dom";
import { NEWS_POSTS } from "./U2News"; //[cite: 3] 关键：引用 U2News 里的数据
import { ChevronLeft, Calendar, User } from "lucide-react";

export default function NewsDetail() {
  const { id } = useParams();
  // 关键修复：使用正确的变量名 NEWS_POSTS[cite: 3]
  const post = NEWS_POSTS.find(p => p.id === parseInt(id));

  if (!post) return (
    <div className="bg-[#07070a] min-h-screen flex items-center justify-center text-white">
      <div className="text-center">
        <h2 className="text-2xl mb-4">Post not found.</h2>
        <Link to="/u2-news" className="text-orange-500 underline">Back to News</Link>
      </div>
    </div>
  );

  return (
    <div className="bg-[#07070a] min-h-screen text-zinc-100 pt-32 pb-20 px-4">
      <div className="max-w-4xl mx-auto">
        <Link to="/u2-news" className="inline-flex items-center gap-2 text-zinc-500 hover:text-orange-500 mb-8 transition-colors">
          <ChevronLeft className="w-4 h-4" /> Back to News
        </Link>
        
        <h1 className="text-4xl md:text-5xl font-display font-bold mb-6 leading-tight text-zinc-50">
          {post.title}
        </h1>

        <div className="flex items-center gap-6 text-sm text-zinc-500 mb-8 border-y border-zinc-800 py-4">
          <span className="flex items-center gap-2"><User className="w-4 h-4" /> {post.author}</span>
          <span className="flex items-center gap-2"><Calendar className="w-4 h-4" /> {post.date}</span>
        </div>

        <img src={post.image} alt={post.title} className="w-full rounded-2xl mb-10 shadow-2xl shadow-orange-500/5" />
        
        <div className="prose prose-invert max-w-none">
          <p className="text-xl text-zinc-300 leading-relaxed mb-6 font-medium">
            {post.excerpt}
          </p>
          <div className="text-zinc-400 leading-loose space-y-4">
            <p>Welcome to the official U2 Group strategy hub. In this article, we delve deep into the mechanics of your favorite games to help you maximize your winnings at <strong>Online Casino Malaysia</strong>.</p>
            <p>Our experts have analyzed the patterns and RTP (Return to Player) data to ensure you have the best information before you start your next session.</p>
            {/* 未来你可以在这里添加更多具体的 HTML 正文内容 */}
          </div>
        </div>
      </div>
    </div>
  );
}
